import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default defineNuxtPlugin((nuxtApp) => {
  // Configure NProgress color
  NProgress.configure({
    showSpinner: false
  });

  // Set custom color via CSS
  if (process.client) {
    const style = document.createElement('style');
    style.textContent = `
      #nprogress .bar {
        background: #f0b90b !important;
      }
      #nprogress .peg {
        box-shadow: 0 0 10px #f0b90b, 0 0 5px #f0b90b !important;
      }
    `;
    document.head.appendChild(style);
  }

  const router = useRouter();

  router.beforeEach(() => {
    NProgress.start();
  });

  router.afterEach(() => {
    NProgress.done();
  });
});
